import CardImageGallery from "./CardImageGallery";
import { getImageUrl } from "../../utils/imageHelper";

const NotableProjects = ({ projects: dynamicProjects }) => {
  const staticProjects = [
    {
      title: "Credit Risk Decision Engine",
      description:
        "predict the probability that an applicant will experience serious delinquency while keeping the model explainable and properly calibrated",
      image:
        "https://as1.ftcdn.net/jpg/03/21/41/14/1000_F_321411435_294H34Tx52o2JDCn783ai3uzc5OCuBln.jpg",
    },
    {
      title: "Model Risk Audit Dashboard",
      description:
        "Is the credit-risk model reliable, stable, explainable, and safe enough for production use",
      image:
        "https://as1.ftcdn.net/jpg/03/21/41/14/1000_F_321411435_294H34Tx52o2JDCn783ai3uzc5OCuBln.jpg",
    },
    {
      title: "Marketing Incrementality Lab",
      description:
        "Which customers should receive a marketing offer when the goal is incremental conversion—not simply predicting who is already likely to convert",
      image:
        "https://as1.ftcdn.net/jpg/03/21/41/14/1000_F_321411435_294H34Tx52o2JDCn783ai3uzc5OCuBln.jpg",
    }
  ];

  const projects =
    dynamicProjects && dynamicProjects.length > 0
      ? dynamicProjects.map((p) => ({
          ...p,
          image: getImageUrl(p.image),
        }))
      : staticProjects;

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 md:gap-12">
        {projects.map((project, index) => (
          <div
            key={index}
            className="group bg-white rounded-[2rem] md:rounded-[3rem] border border-slate-200/60 overflow-hidden shadow-sm hover:shadow-2xl hover:shadow-blue-200/40 transition-all duration-500 h-full hover:-translate-y-2"
          >
            <CardImageGallery imageSrc={project.image} altTitle={project.title} className="h-64 md:h-80" />
            <div className="p-6 md:p-10">
              <h3 className="text-xl md:text-2xl font-black text-slate-900 mb-3 md:mb-4 tracking-tight group-hover:text-blue-600 transition-colors">
                {project.title}
              </h3>
              <p className="text-slate-500 text-sm md:text-base font-medium leading-relaxed">
                {project.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotableProjects;
